import {
  addShipManagementDetailsAPI,
  deleteShipManagementDetailsAPI,
  getShipManagementDetailsAPI,
  updateShipManagementDetailsAPI,
} from "./api";

export const addShipManagementDetails = (id, data) => {
  return new Promise((resolve, reject) => {
    addShipManagementDetailsAPI(id, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateShipManagementDetails = (data) => {
  return new Promise((resolve, reject) => {
    updateShipManagementDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getShipManagementDetails = (data) => {
  return new Promise((resolve, reject) => {
    getShipManagementDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteShipManagementDetails = (data) => {
  return new Promise((resolve, reject) => {
    deleteShipManagementDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};